import ChevronRightFilled from './src/chevron-right-filled';
export default ChevronRightFilled;